export default __webpack_public_path__ + "static/media/006-knitting.ac387096.svg";